module.exports = __webpack_public_path__ + "static/media/REPstrainer3.4decf224.jpg";